/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import { communicationService, authService } from '@/services';
import map from 'lodash/map';

function getName(minor) {
  if (minor) {
    return `${minor.name} ${minor.surname}`;
  }
  return '';
}

export const getters = {
  inbox: state => state.inbox,
  outbox: state => state.outbox,
  email: state => state.email,
  recipients: state => state.recipients,
  inboxCount: state => state.inboxCount,
  getOutboxName: state =>
    (state.email ? map(state.email.minors, getName).join(', ') : ''),
  getInboxName: state => (role) => {
    let data = '';
    if (state.email) {
      if (role === 'teacher') {
        if (state.email.minor) {
          data = `${state.email.minor.name} ${state.email.minor.surname}`;
        }
      }
      if (role === 'tutor') {
        data = `${state.email.institute_name} - ${state.email.classroom_name}`;
      }
    }
    return data;
  },
};

export const state = {
  inbox: [],
  email: {},
  outbox: [],
  recipients: [],
  inboxCount: 0,
};
export const actions = {
  getTeacherInbox({ commit, dispatch }, { classroom_id }) {
    dispatch('setClassroom', classroom_id, { root: true });
    communicationService
      .getTeacherInbox(classroom_id)
      .then((response) => {
        commit('GET_INBOX', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  getTeacherOutbox({ commit, dispatch }, { classroom_id }) {
    dispatch('setClassroom', classroom_id, { root: true });
    communicationService
      .getTeacherOutbox(classroom_id)
      .then((response) => {
        commit('GET_OUTBOX', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  getRecipientsList({ commit, dispatch }, { classroom_id }) {
    dispatch('setClassroom', classroom_id, { root: true });
    communicationService
      .recipientsList(classroom_id)
      .then((response) => {
        commit('GET_RECIPIENTS_LIST', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  sendCommunication(
    { commit, dispatch },
    {
 receivers, subject, message, notify, route, role
},
  ) {
    if (role === 'teacher') {
      dispatch('setClassroom', route.params.id, { root: true });
      return communicationService
        .createTeacherCommunication({
          receivers,
          subject,
          message,
          notify,
          classroom_id: route.params.id,
        })
        .then(response => response)
        .catch((error) => {
          dispatch(
            'notificationService',
            { type: 'error', text: error },
            { root: true },
          );
        });
    }
    dispatch('setClassroom', route.query.class, { root: true });
    return communicationService
      .createTutorCommunication({
        minor_id: route.params.id,
        subject,
        message,
        notify: false,
        classroom_id: route.query.class,
      })
      .then(response => response)
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  getTutorOutbox({ commit }, { minorId }) {
    communicationService.getTutorOutbox(minorId).then((response) => {
      commit('GET_OUTBOX', response);
    });
  },
  getTutorInbox({ commit, dispatch }, { minorId }) {
    communicationService
      .getTutorInbox(minorId)
      .then((response) => {
        commit('GET_INBOX', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  getInboxEmail({ commit, dispatch }, { id }) {
    communicationService
      .getInboxEmail(id)
      .then((response) => {
        commit('GET_EMAIL', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  getOutboxEmail({ commit, dispatch }, { id }) {
    communicationService
      .getOutboxEmail(id)
      .then((response) => {
        commit('GET_EMAIL', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  getCommunicationTutorCount({ commit, dispatch }, { minorId }) {
    communicationService
      .getTutorCount(minorId)
      .then((response) => {
        commit('INBOX_COUNT', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  getTeacherCount({ commit, dispatch }, { classroomId }) {
    dispatch('setClassroom', classroomId, { root: true });
    communicationService
      .getTeacherCount(classroomId)
      .then((response) => {
        commit('INBOX_COUNT', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  async deleteCommunication({ commit, dispatch }, { communicationId }) {
    await communicationService
      .deleteCommunication(communicationId)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
};

export const mutations = {
  GET_INBOX(state, data) {
    state.inbox = {
      items: data,
    };
  },
  GET_OUTBOX(state, data) {
    state.outbox = {
      items: data,
    };
  },
  GET_EMAIL(state, data) {
    state.email = data;
  },
  GET_RECIPIENTS_LIST(state, data) {
    state.recipients = {
      items: data,
    };
  },
  INBOX_COUNT(state, data) {
    state.inboxCount = data;
  },
};
